import { render, staticRenderFns } from "./RegistrarPartida.vue?vue&type=template&id=6977c772"
import script from "./RegistrarPartida.vue?vue&type=script&lang=js"
export * from "./RegistrarPartida.vue?vue&type=script&lang=js"
import style0 from "./RegistrarPartida.vue?vue&type=style&index=0&id=6977c772&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports